import {
  CategoryScale,
  Chart,
  Title,
  Tooltip,
  LinearScale,
  LineElement,
  PointElement,
  ArcElement,
  Legend,
} from "chart.js";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import React, { useState, SyntheticEvent } from "react";
import { useGetClientsQuery } from "../../apis/clients";
import ClientRequest from "../../components/Client/ClientRequest";

Chart.register(
  Title,
  Tooltip,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  ArcElement,
  Legend,
);

const ClientAnalytics = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { data: clients = [] } = useGetClientsQuery();
  const handleChange = (_event: SyntheticEvent, newIndex: number) => setTabIndex(newIndex);
  return (
    <Stack spacing={3}>
      <Typography variant="h4">Analytics</Typography>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        {clients.map((client, index) => (
          <Tab key={client.id} label={client.name} value={index} />
        ))}
      </Tabs>

      <Box>
        {clients.map((client, index) => (
          <Box key={client.id}>{index !== tabIndex ? null : <ClientRequest client={client} />}</Box>
        ))}
      </Box>
    </Stack>
  );
};

export default ClientAnalytics;
